import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import DropWrapper from 'global/dragNDrops/DropWrapper'
import { _longPressDisplayTypes, _longPressTypes, LongPressWrapper, LPW } from 'global/wrappers/LongPressWrapper'
import _ from 'lodash'
import { sportsEloHelpers } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/eloInfo'
import { useMatchDisplayType } from 'projectSpecific/sports/useHelpers/useMatchDisplayType'
import { _matchResultSourceTypes, useMatchResults } from 'projectSpecific/sports/useHelpers/useMatchResults'
import { useMatchVideos } from 'projectSpecific/sports/useHelpers/useMatchVideos'
import { useCallback, useContext, useMemo, useState } from 'react'
import { Icon, Label } from 'semantic-ui-react'
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext'
import { uniqueKey } from '../../../../global/common/keys'
import { gEnums } from '../../../../global/enums/globalEnums'
import SportsMatchProvider, { SportsMatchContext } from '../../cnr/contexts/SportsMatchContext'
import SportsRtMatchProvider, { SportsRtMatchContext } from '../../cnr/contexts/SportsRtMatchContext'
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext'
import { CreatePlayoffContext } from '../../create/CreatePlayoff'
import MatchDivs from './MatchDivs'
import { matchFilterHelpers } from './MatchFilters'
import MatchForm from './MatchForm'
import MatchPredication from './MatchPredication'
import MatchOptionsSquares from './MatchOptionsSquares'
import MatchScores from './MatchScores'
import MatchScoreKeypad from './MatchScoreKeypad'
import RealtimeScorekeeper from './RealtimeScorekeeper'
import MatchRealtimeScores from './MatchRealtimeScores'
import usePageNavigation from 'global/cnr/contexts/useHelpers/usePageNavigation'

export const _matchDisplayTypes = {
  levelMatches_playoffs: 'levelMatches_playoffs',
  levelMatches: 'levelMatches',
  levelMatchNoScore_playoffs: 'levelMatchNoScore_playoffs',
  levelMatchNoScore: 'levelMatchNoScore',
  levelOverviewMatches: 'levelOverviewMatches',
  playoff_grid_noScore_pending: 'playoff_grid_noScore_pending',
  playoff_grid_pending: 'playoff_grid_pending',
  playoff_grid_pendingA: 'playoff_grid_pendingA',
  playoff_grid_noScore_pendingA: 'playoff_grid_noScore_pendingA',
  playoff_grid_noScore: 'playoff_grid_noScore',
  playoff_grid: 'playoff_grid',
  playoff_grid_dash: 'playoff_grid_dash',
  playoff_noScore: 'playoff_noScore',
  playoff: 'playoff',
  playoffMatchAwayPending: 'playoffMatchAwayPending',
  playoffMatchPending: 'playoffMatchPending',
  playoffPending: 'playoffPending',
  playoffPendingAway: 'playoffPendingAway',
  scoreboard_playoffs: 'scoreboard_playoffs',
  scoreboard: 'scoreboard',
  teamMatches: 'teamMatches',
  teamMatchesNoScore_playoffs: 'teamMatchesNoScore_playoffs',
  teamMatchesNoScore: 'teamMatchesNoScore',
  teamMatchNoScore: 'teamMatchNoScore',
}

export const matchPropTypes = Object.freeze({
  startDate: 'startDate',
  startTime: 'startTime',
  awayName: 'away.name',
  homeName: 'home.name',
  opponentName: 'opponent.name',
  awaySeed: 'away.seed',
  homeSeed: 'home.seed',
  locationName: 'location.name',
  ls: 'ls',
  matchNumber: 'matchNumber',
  pendingAwayOriginalSeed: 'pending.away.originalSeed',
  pendingAwayMatchNumber: 'pending.away.matchNumber',
  pendingHomeOriginalSeed: 'pending.home.originalSeed',
  pendingHomeMatchNumber: 'pending.home.matchNumber',
  pendingAwaySeed: 'pending.away.seed',
  pendingAwayName: 'pending.away.name',
  pendingHomeSeed: 'pending.home.seed',
  pendingHomeName: 'pending.home.name',
  _results: '_results',
  _resultsScoreAway: '_results.score.away',
  _resultsScoreHome: '_results.score.home',
  matchNumber: 'matchNumber',
  videoUrl: 'videoUrl'
});

const _cnOpts = {
  amed: 'amed',
  amrz: 'amrz',
  bye: 'bye',
  cmt: 'cmt',
  cld: 'cld',
  mdc: 'mdc',
  min: 'min',
  miz: 'miz',
  mrt: 'mrt',
  mmd: 'mmd',
  msc: 'msc',
  msn: 'msn',
  ply: 'ply',
  pnd: 'pnd',
  pnda: 'pnda',
  pndi: 'pndi',
  pred: 'pred',
  pst: 'pst',
  rez: 'rez',
  rmd: 'rmd',
  rmdish: 'rmdish',
  rrt: 'rrt',
  smo: 'smo',
  fav: 'fav',
  smu: 'smu',
}

const MatchContent = (props) => {

  const {
    matchDisplayType = _matchDisplayTypes.levelMatches,
    matchKey,
    parentKey,
    teamKey,
    matchScheduleDisplayType,
    oppsOnly,
    dateKey,
    allowDrag,
    match_missAssigned,
    oc
  } = props

  const upn = usePageNavigation()

  const [isVisible, setIsVisible] = useState(true);

  const setRef = useCallback(node => {
    if (node) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        },
        { rootMargin: '300px 0px' }
      );

      observer.observe(node);
    }
  }, []);

  const appUserAccess = useAppUserAccess()
  const { isSuperAdminDeveloper } = appUserAccess ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { paps_state } = states ?? {};
  const { pathViews } = paps_state ?? {};

  const _teamKey = teamKey ? teamKey : pathViews?.teams

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { teams_info, details_info, realtimeResults, matches_info, matchDayResults } = sportsSeason_state ?? {};
  const { teams } = teams_info ?? {};
  const { details } = details_info ?? {}
  let { showPredictions } = details ?? {}
  const { matchPlayoffPendings } = matches_info ?? {}

  showPredictions = true

  const rtm = realtimeResults?.[matchKey]
  const hpn = matchPlayoffPendings?.[matchKey]
  const mdr = matchDayResults?.[matchKey]

  // createPlayoffContext
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state, createPlayoff_handlers } = createPlayoffContext ?? {};

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state } = sportsMatchContext ?? {}
  const { match_true, matchAllows } = sportsMatch_state ?? {}
  const { edit: _allowEdit_match, scores: _allowEdit_scores } = matchAllows ?? {}

  // sportsRtMatchContext
  const sportsRtMatchContext = useContext(SportsRtMatchContext)
  const { sportsRtMatch_state } = sportsRtMatchContext ?? {}
  const { showRealtimeScoring } = sportsRtMatch_state ?? {}

  const {
    _favTeamKey,
    _isCancelled,
    _isPostponed,
    _matchChanges,
    _results,
    _status,
    _updated,
    isPlayoff,
    matchStatus,
    _startDateChanged,
    _nonGs,
  } = match_true ?? {}

  if (hpn && match_true) {
    match_true.away = hpn.away
    match_true.home = hpn.home
  }

  const { matchUrl } = useMatchVideos(match_true)

  const _umr = useMatchResults({ match_true })
  const { results_match, results_realtime, result_matchDay, result_source, hasScore, hasScores } = _umr

  let _results_combined = _results ? _.cloneDeep(_results) : {}

  if (match_true && match_true.pending && !match_true.home) {
    match_true.home = match_true.pending.home
    const ph = match_true.pending.home
    match_true.home.name = `${ph.place}/${ph.poolName}/${ph.matchKey}`
  }

  if (match_true && match_true.pending && !match_true.away) {
    match_true.away = match_true.pending.away
    const pa = match_true.pending.away
    match_true.away.name = `${pa.place}/${pa.poolName}/${pa.matchKey}`
  }

  const { isMissing, isBye, isPending, isPendingish, isPendingAway } = _status ?? {}
  const { matchCn, complete, winner } = _results_combined ?? {}

  let showScores;

  let _matchPropType = matchDisplayType

  const { matchProps } = useMatchDisplayType({ match_true, matchUrl, matchDisplayType: props.matchDisplayType })

  let _forGrid = _matchPropType?.includes('grid');

  switch (matchDisplayType) {
    case _matchDisplayTypes.playoff_grid:
    case _matchDisplayTypes.playoff_grid_dash:
      showScores = hasScores || results_match
      break;
    case _matchDisplayTypes.levelOverviewMatches:
      showScores = false
      break;
    case _matchDisplayTypes.teamMatches:
      showScores = false
      break;
    default:
      showScores = hasScores || results_match
  }

  switch (matchScheduleDisplayType) {
    case gEnums.matchScheduleDisplayTypes.currentMatches:
    case gEnums.matchScheduleDisplayTypes.matchDay:
    case gEnums.matchScheduleDisplayTypes.missing:
    case gEnums.matchScheduleDisplayTypes.pendingMatches:
      showScores = false
      break;
    case gEnums.matchScheduleDisplayTypes.playoff_grid_dash:
      break;
    default:
  }

  const allowEdits = useMemo(() => {
    switch (matchDisplayType) {
      case _matchDisplayTypes.scoreboard:
      case _matchDisplayTypes.teamMatches:
      case _matchDisplayTypes.levelMatches:
        if (_allowEdit_match || _allowEdit_scores) {
          return true
        }
    }
  }, [match_true, _allowEdit_match, _allowEdit_scores])

  const { matchPredictor, hasPrediction } = useMemo(() => {
    if (!dateKey || !isPlayoff || _forGrid || complete || !showPredictions) return { predictor: null, hasPrediction: false };
    const prediction = sportsEloHelpers.getMatchPrediction({ match: match_true, teams, includeCommonMatches: true })
    if (!prediction) return { predictor: null, hasPrediction: false };
    return {
      matchPredictor: <MatchPredication match={match_true} />,
      hasPrediction: true
    }
  }, [match_true?._itemKey])

  const handleMatchClick = (e) => {
    e.stopPropagation()
    if (oc) {
      oc(match_true)
      return;
    }
    if (createPlayoff_state) return;
    switch (matchScheduleDisplayType) {
      case gEnums.matchScheduleDisplayTypes.currentMatches:
      case gEnums.matchScheduleDisplayTypes.matchDay:
      case gEnums.matchScheduleDisplayTypes.missing:
      case gEnums.matchScheduleDisplayTypes.pendingMatches:
        break;
      default:
        if (match_true) upn.handleNav_item({ key: 'matches' }, match_true._itemKey)
    }
  }

  const cnn = () => {

    let _cn;
    let noPred;

    switch (matchDisplayType) {
      case _matchDisplayTypes.playoff_grid_noScore_pending:
      case _matchDisplayTypes.playoff_grid_noScore_pendingA:
      case _matchDisplayTypes.playoff_grid_noScore:
      case _matchDisplayTypes.playoff_grid:
        _cn = ['match-gridd']
        break;
      case _matchDisplayTypes.playoff_grid_dash:
        _cn = ['match-gridd dash']
        noPred = true
        break;
      default:
        _cn = ['match-wrapperr']
    }

    if (matchCn) _cn.push(matchCn)

    if (_matchChanges?.dateChanged) _cn.push(_cnOpts.mdc)
    if (_matchChanges?.matchIsNew) _cn.push(_cnOpts.min)
    if (_matchChanges?.matchStatusChanged || matchStatus === 'canceled') _cn.push(_cnOpts.cld)

    if ((winner || results_match) && !isBye) _cn.push(_cnOpts.rez)
    if (isMissing && !isBye) _cn.push(_cnOpts.miz)

    if (_results_combined?._resultsFrom === 'matchDay') _cn.push(_cnOpts.rmd)
    if (_results_combined?._resultsFrom === 'matchDayish') _cn.push(_cnOpts.rmdish)
    if (_results_combined?._resultsFrom === 'realtime') _cn.push(_cnOpts.rrt)

    if (winner && [gEnums.matchScheduleDisplayTypes.teamSchedule, gEnums.matchScheduleDisplayTypes.teamScheduleMini, gEnums.matchScheduleDisplayTypes.levelOverviewMatches].includes(matchScheduleDisplayType)) {
      _cn.push(winner?.id === _teamKey ? 'win' : 'loss')
    }

    if (allowEdits && _allowEdit_scores) _cn.push(_cnOpts.amrz)
    if (allowEdits && _allowEdit_match) _cn.push(_cnOpts.amed)

    if (complete) {
      _cn.push(_cnOpts.cmt)
    }

    if (isPlayoff) {
      switch (matchScheduleDisplayType) {
        case gEnums.matchScheduleDisplayTypes.teamSchedule:
          break;
        default:
          _cn.push(_cnOpts.ply)
          if (match_true.isFirstRound && (match_true?.away?.sections === match_true?.home?.sections)) {
            // _cn.push(_cnOpts.smu)
          }
      }

      if (isBye) {
        _cn.push(_cnOpts.bye)
      }

      if (hasPrediction && !noPred) {
        _cn.push(_cnOpts.pred)
      }
    }

    if (_isCancelled) {
      _cn.push(_cnOpts.cld)
    }

    if (_isPostponed) {
      _cn.push(_cnOpts.pst)
    }

    if (_favTeamKey) {
      _cn.push(_cnOpts.fav)
    }

    // if (result_source) {
    //   _cn.push(`rst-${result_source}`)
    // }

    if (hpn) {
      _cn.push('hpn')
    }

    if (_updated) {
      _cn.push('upd')
    }

    // if (!isPlayoff && match_missAssigned || match_true?.opponent?.name === 'none') {
    //   _cn.push('msa')
    // }

    if (_startDateChanged) {
      _cn.push('sdc')
    }

    if (_nonGs) {
      _cn.push('sdc')
    }

    return _cn.join(' ')

  }

  // get all the divs for the match based on the matchDisplayType and matchDisplayProps
  const matchDivs = () => <MatchDivs
    _teamKey={_teamKey}
    allowEdits={allowEdits}
    match={match_true}
    matchDisplayType={matchDisplayType}
    matchScheduleDisplayType={matchScheduleDisplayType}
    matchProps={matchProps}
    matchUrl={matchUrl}
    rtm={rtm}
    mdr={mdr}
  />

  const scores_official_element = () => <MatchScores results={_results_combined} forGrid={_forGrid} />
  const scores_realtime_element = (mt) => {
    return <MatchRealtimeScores match_true={mt} results_realtime={results_realtime} result_matchDay={result_matchDay} matchResultSourceType={_matchResultSourceTypes.realtime} />
  }

  const mos = () => <MatchOptionsSquares match_true={match_true} matchDisplayType={matchDisplayType} />

  const handleDrop = (dragData) => {
    const { match } = dragData ?? {}
    const _match_true = _.cloneDeep(match_true)
    _match_true.location = match.location
    createPlayoff_handlers.handleAmmend_match(_match_true)
  }

  const allowDrop = useMemo(() => {
    return createPlayoff_state ? true : false
  })

  const content = () => {
    return <div
      // title={match_missAssigned && }
      ref={setRef}
      key={parentKey ? uniqueKey(parentKey, matchKey) : uniqueKey(matchKey || 'asdf')}
      className={cnn()}
      draggable={allowDrag}
      onDragStart={(e) => {
        if (!allowDrag) return;
        const dt = {
          _itemKey: match_true?._itemKey,
          itemType: 'match',
        }
        e.dataTransfer.setData('application/json', JSON.stringify(dt));
      }}
      style={{ cursor: allowDrag ? 'grab' : null }}
    >
      {isVisible && matchDivs()}
      {showScores && hasScores && result_source === _matchResultSourceTypes.official && scores_official_element()}
      {/* <div>TEST</div> */}
      {/* {scores_realtime_element(match_true)} */}
      {isPlayoff && hasPrediction && matchPredictor}
    </div>
  };


  const matchContent = () => {
    if (!match_true) return <div></div>;
    return <LPW
      allowHoldingStart={true}
      itemData={match_true}
      longPressType={_longPressTypes.match}
      longPressModal={{ content: mos() }}
      onClick={handleMatchClick}
      longPressDisplayType={_longPressDisplayTypes.full}
      disallowLpw={isSuperAdminDeveloper ? false : false}
    >
      {allowDrop ? <DropWrapper onDropItem={handleDrop}>{content()}</DropWrapper> : content()}
    </LPW>
  } //, [JSON.stringify(match_true), JSON.stringify(result_matchDay), complete, results_realtime, result_matchDay])

  return <div>
    {matchContent()}
    {showRealtimeScoring && <RealtimeScorekeeper match_true={match_true} />}
  </div>

}

export default MatchContent

/**
 * 
 * @param {*} props 
 * @returns a single match 
 */
export const MatchContentWithProvider = (props) => {
  return <SportsMatchProvider {...props}>
    <SportsRtMatchProvider {...props}>
      <MatchContent {...props} />
    </SportsRtMatchProvider>
  </SportsMatchProvider>
}